import React, { useState } from 'react';
import './style.scss';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import Message from '../../../../components/message';
import Form from 'react-bootstrap/Form';
import Button from '../../../../components/primitives/button';
import PropTypes from 'prop-types';
import { IoClose } from 'react-icons/io5';
import { sendFeedback } from '../../infrastructure/api/feedback.api';

const initFormValues = {
  email: '',
  title: '',
  phone: '',
  description: '',
  picture: '',
};

const FeedBack = (props) => {
  const { t } = useTranslation();
  const [isMessage, setMessage] = useState(null);
  const [isFormHide, setFormHide] = useState(false);
  const [formValues, setFormValues] = useState({
    email: '',
    title: '',
    description: '',
    picture: '',
  });

  const handleSubmit = async (data) => {
    try {
      await sendFeedback(data);
    } catch (error) {
      return setMessage({
        value: t('Something wrong'),
        timeout: 3000,
      });
    }
    setFormValues(initFormValues);
    setMessage({
      value: t('feedback.successful'),
      timeout: 0,
    });
    setFormHide(true);
    setTimeout(() => props.hide(true), 4000);
  };

  return (
    <div className="feedback-panel br-16">
      <button className="icon-close fa-trash cursor-pointer fs-4" onClick={() => props.hide()}>
        <IoClose></IoClose>
      </button>
      <Formik<any> initialValues={formValues} onSubmit={handleSubmit}>
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
          <form onSubmit={handleSubmit} className="p-16">
            <div className="block-title mb-2">
              <h2 className="title fs-3">{t('feedback.heading')}</h2>
              <span className="fs-6">{t('feedback.subTitle')}</span>
            </div>
            {isMessage && <Message setMessage={setMessage} {...isMessage}></Message>}
            {!isFormHide && (
              <>
                <div className="row mb-2 form-group">
                  <div className="col-12">
                    <Form.Label htmlFor="email">{t('feedback.email')}</Form.Label>
                    <Form.Control
                      id="email"
                      className={`form-control ${errors.email && touched.email ? 'is-invalid' : ''}`}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                    ></Form.Control>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-12">
                    <Form.Label htmlFor="title">{t('feedback.title')}</Form.Label>
                    <Form.Control
                      id="title"
                      className={`form-control ${errors.title && touched.title ? 'is-invalid' : ''}`}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.title}
                    ></Form.Control>
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-12">
                    <Form.Label htmlFor="description">{t('feedback.description')}</Form.Label>
                    <Form.Control
                      multiple
                      id="description"
                      className={`form-control ${errors.description && touched.description ? 'is-invalid' : ''}`}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.description}
                    ></Form.Control>
                  </div>
                </div>
                <Button
                  onClick={() => {}}
                  className="btn btn-secondary mt-16"
                  iconClass="icon-arrow-right-white"
                  disabled={isSubmitting}
                  title={t('feedback.send')}
                ></Button>
              </>
            )}
          </form>
        )}
      </Formik>
    </div>
  );
};

FeedBack.propTypes = {
  hide: PropTypes.func.isRequired,
};

export default FeedBack;
